class TextReadMore extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-text-read-more-viewport]');
    this.toggleButton = this.querySelector('[data-text-read-more-toggle]');
    if (!this.viewport || !this.toggleButton) return;

    this.maxHeight = parseInt(this.dataset.maxHeight, 10) || 120;
    this.isExpanded = this.dataset.expanded === 'true';
    this.moreLabel = this.dataset.moreLabel;
    this.lessLabel = this.dataset.lessLabel;

    this.checkHeight = this.checkHeight.bind(this);
    this.onToggle = this.onToggle.bind(this);
    
    this.toggleButton.addEventListener('click', this.onToggle);
    window.addEventListener('resize', this.checkHeight);

    // Initial check with a small delay to ensure styles/fonts are loaded and layout is calculated
    setTimeout(this.checkHeight, 100);
    // Also observe the viewport if content images load
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.dataset.expanded !== 'true') {
          this.checkHeight();
        }
      });
      this.resizeObserver.observe(this.viewport);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.checkHeight);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  checkHeight() {
    if (this.dataset.expanded === 'true') return;
    
    if (this.viewport.scrollHeight > this.maxHeight) {
      this.classList.add('text-read-more--collapsed');
      this.toggleButton.hidden = false;
    } else {
      this.classList.remove('text-read-more--collapsed');
      this.toggleButton.hidden = true;
    }
  }

  onToggle() {
    this.isExpanded = !this.isExpanded;
    this.dataset.expanded = this.isExpanded;
    
    if (this.isExpanded) {
      this.classList.remove('text-read-more--collapsed');
      this.toggleButton.textContent = this.lessLabel;
    } else {
      this.classList.add('text-read-more--collapsed');
      this.toggleButton.textContent = this.moreLabel;
    }
  }
}

if (!customElements.get('text-read-more')) {
  customElements.define('text-read-more', TextReadMore);
}
